import { Divider, useTheme } from "@mui/material";

function TopBarDivider() {
    const theme = useTheme();
    return <Divider sx={{ backgroundColor: theme.customPalette.topBarDivider, marginX: theme.spacing(6), marginY: theme.spacing(2) }} />;
}

export default TopBarDivider;
